import * as Sentry from '@sentry/vue';
import Vue from 'vue';

export default function initSentry({ router }) {
  if (!process.env.SENTRY_DSN_FRONT) {
    return;
  }

  Sentry.init({
    Vue,
    dsn: process.env.SENTRY_DSN_FRONT,
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.replayIntegration(),
    ],

    tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE_FRONT,
    replaysSessionSampleRate: process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE_FRONT,
    replaysOnErrorSampleRate: process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE_FRONT,
  });
}
